import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import { useQuizContext } from "./QuizContext";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import "./SignupCommon.css";

const SignupPage7: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const { setAnswer } = useQuizContext();

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (selectedOption) {
      localStorage.setItem(
        "past_illness",
        JSON.stringify({
          key: "past_illness",
          value: selectedOption,
          id: 18026058,
        })
      );
      setAnswer("past_illness", selectedOption, "18026058");
    }
    if(selectedOption === "None of the Following"){
      navigate("/getting-started/step-5")
    }else{
      navigate("/getting-started/invalid-age")
    }
    localStorage.setItem("step-4-completed", "true");
  };
  const navigate = useNavigate();

  useEffect(() => {
    const step3Completed = localStorage.getItem("step-3-completed");
    if (step3Completed) {
      navigate("/getting-started/step-4",{ replace: true });
    } else {
      navigate("/getting-started/step-3",{ replace: true });
    }
  }, []);

  useEffect(() => {
    const savedPastIllness = localStorage.getItem("past_illness");

    if (savedPastIllness) {
      const parsedPastIllness = JSON.parse(savedPastIllness);
      setSelectedOption(parsedPastIllness.value);
    }
  }, []);

  const options = [
    "None of the Following",
    "End-stage kidney disease",
    "End-stage liver disease",
    "Current suicidal thoughts and/or prior suicidal attempt",
    "Cancer",
    "History of Organ Transplant on anti-rejection medication",
    "Severe gastrointestinal condition",
    "Current diagnosis of or treatment for alcohol, opioid, or substance use disorder/dependence",
    "Uncontrolled diabetes",
  ];

  const step = 4;

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={40} step={step} />
        <div className="signup-content">
          <p className="signup-intro">
            Have you experienced any significant medical conditions, either
            currently or in the past, that could impact your health and wellness
            journey?
          </p>
          <div className="options">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          <button 
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={!selectedOption}
            >
             Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage7;
